// import './vendor/fittext.js';
//
// // on ducoment ready
// document.addEventListener('DOMContentLoaded', () => {
//     const elementsToFitText = document.querySelectorAll('.fit-text');
//     console.error(elementsToFitText);
//     elementsToFitText.forEach((element) => {
//         console.log(element);
//         window.fitText(element, 1.2);
//     });
// });
